// @flow

import Markdoc from '@markdoc/markdoc';

import type {RenderableTreeNode} from '@markdoc/markdoc';
import type {Config} from 'docs/markdoc';

const tokenizer = new Markdoc.Tokenizer({
  typographer: true,
  allowIndentation: true,
});

// TODO(DOCSPRODUCT-708): Create better system for rendering Markdown from Ruby
export function unsafelyParseMarkdown(
  string: string,
  config: Config,
): RenderableTreeNode | Array<RenderableTreeNode> {
  try {
    const tokens = tokenizer.tokenize(string);
    const mdast = Markdoc.parse(tokens);
    return Markdoc.transform(mdast, config);
  } catch {
    return '';
  }
}
